<template>
    <div class="image-list" v-if="vehicle && vehicle.images">
        <div class="image-list-item"
             @mouseover.once="getAllVehicleImages(vehicle)"
             @mouseover="showBox='front',showBoxFunc($event)"
             @mouseleave="showBox=false">
            <template v-if="letters_only">F</template>
            <template v-else>Front</template>
            <div class="image-hover"
                 v-bind:class="[showBox==='front' ? 'show' : 'hide',boxLeft ? 'right' : 'left', boxTop ? 'top' : 'bottom']"
                 v-bind:style="styleObject"
            >
                <img :src="frontImageSrc" alt="Front"
                     v-if="load_images && frontImageSrc">
            </div>
        </div>
        <div class="line"></div>
        <div class="image-list-item"
             @mouseover.once="getAllVehicleImages(vehicle)"
             @mouseover="showBox='back',showBoxFunc($event)"
             @mouseleave="showBox=false">
            <template v-if="letters_only">B</template>
            <template v-else>Back</template>
            <div class="image-hover"
                 v-bind:class="[showBox==='back' ? 'show' : 'hide',boxLeft===true ? 'right' : 'left', boxTop ? 'top' : 'bottom']"
                 v-bind:style="styleObject"
            >
                <img :src="backImageSrc" alt="Back"
                     v-if="load_images && backImageSrc">
            </div>
        </div>
        <div class="line"></div>
        <div class="image-list-item"
             @mouseover.once="getAllVehicleImages(vehicle)"
             @mouseover="showBox='interior',showBoxFunc($event)"
             @mouseleave="showBox=false">
            <template v-if="letters_only">I</template>
            <template v-else>Interior</template>
            <div class="image-hover"
                 v-bind:class="[showBox==='interior' ? 'show' : 'hide',boxLeft===true ? 'right' : 'left', boxTop ? 'top' : 'bottom']"
                 v-bind:style="styleObject"
            >

                <img :src="interiorImageSrc" alt="Interior"
                     v-if="load_images && interiorImageSrc">

            </div>
        </div>
        <template v-if="sheetImageSrc">
            <div class="line"></div>
            <div class="image-list-item"
                 @mouseover.once="getAllVehicleImages(vehicle)"
                 @mouseover="showBox='sheet',showBoxFunc($event)"
                 @mouseleave="showBox=false">
                <template v-if="letters_only">S</template>
                <template v-else>Sheet</template>
                <div class="image-hover"
                     v-bind:class="[showBox==='sheet' ? 'show' : 'hide',boxLeft===true ? 'right' : 'left', boxTop ? 'top' : 'bottom']"
                     v-bind:style="styleObject"
                >

                    <img :src="sheetImageSrc" alt="Sheet"
                         v-if="load_images && sheetImageSrc">

                </div>
            </div>
        </template>
        <div class="line"></div>
        <div class="image-list-item"
             @mouseover.once="getAllVehicleImages(vehicle)"
             @mouseover="showBox='all',showBoxFunc($event)"
             @mouseleave="showBox=false">
            <template v-if="letters_only">A</template>
            <template v-else>All</template>
            <div class="image-hover all"
                 v-bind:class="[showBox==='all' ? 'show' : 'hide',boxLeft===true ? 'right' : 'left', boxTop ? 'top' : 'bottom']"
                 v-bind:style="styleObject"
                 v-if="load_images"
            >
                <div>
                    <div>
                        <img :src="sheetImageSrc" alt="Sheet"
                             v-if="sheetImageSrc">
                    </div>
                    <div>
                        <img :src="frontImageSrc" alt="Front"
                             v-if="frontImageSrc">
                    </div>
                </div>
                <div>
                    <div>
                        <img :src="backImageSrc" alt="Back"
                             v-if="backImageSrc">
                    </div>
                    <div>
                        <img :src="interiorImageSrc"
                             alt="Interior"
                             v-if="interiorImageSrc">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'VehicleHoverImages',
    props: {
        vehicle: {
            type: Object
        },
        letters_only: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            boxLeft: false,
            boxTop: false,
            showBox: false,
            styleObject: {},
            load_images: false
        }
    },
    computed: {
        frontImageSrc() {
            if (!this.vehicle || !this.vehicle.images || !this.vehicle.images.front) {
                return null;
            }
            return this.vehicle.images.front.large || this.vehicle.images.front;
        },
        backImageSrc() {
            if (!this.vehicle || !this.vehicle.images || !this.vehicle.images.back) {
                return null;
            }
            return this.vehicle.images.back.large || this.vehicle.images.back;
        },
        interiorImageSrc() {
            if (!this.vehicle || !this.vehicle.images || !this.vehicle.images.interior) {
                return null;
            }
            return this.vehicle.images.interior.large || this.vehicle.images.interior;
        },
        sheetImageSrc() {
            if (!this.vehicle || !this.vehicle.images || !this.vehicle.images.sheet) {
                return null;
            }
            return this.vehicle.images.sheet.large || this.vehicle.images.sheet;
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        showBoxFunc(event) {
            $(event.target).find('.image-hover').css('opacity', 0);
            let position = $(event.target).offset();
            let width = $(event.target).find('.image-hover').width();

            if ($(event.target).find('.image-hover').hasClass('all')) {
                width = 1034;
            } else {
                width = 1034;
            }
            let heightOffset = position.top - $(window).scrollTop()
            if (heightOffset > ($(window).height() / 2)) {
                this.boxTop = true;
            } else {
                this.boxTop = false;
            }

            let horizontal = position.left + width;
            if (horizontal > $(window).width()) {
                this.boxLeft = true;
                let offsetX = position.left - width;
                if (offsetX > 0) {
                    this.styleObject.left = 'auto';
                } else {
                    this.styleObject.left = offsetX * -1 + 'px';
                }
            } else {
                this.boxLeft = false;
                this.styleObject.left = 'auto';
            }
            $(event.target).find('.image-hover').css('opacity', 1);
        },
        getAllVehicleImages(vehicle) {
            if (!this.load_images) {
                this.load_images = true;
            }
        }
    }


}
</script>

<style scoped lang="scss">

@import "./resources/sass/mixins";
@import "./resources/sass/variables";

.image-list {
    display: flex;
    justify-content: space-between;
    flex-flow: row nowrap;
    position: relative;
    @include pddm_respond_to(xs-down){
        position: initial;
    }
    .image-list-item {
        cursor: pointer;
        color: $blue;
        transition: all 0.3s ease;
        text-align: center;
        padding-bottom: 10px;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 5px;
        position: relative;
        @include pddm_respond_to(xs-down){
            position: initial;
        }
        &:first-child{
            padding-left: 0;
        }
        &:last-child{
            padding-right: 0;
        }

        .image-hover {
            pointer-events: none;
            position: absolute;
            padding: 5px;
            background-color: $white;
            z-index: 999;
            -webkit-box-shadow: 0px 14px 51px -13px rgba(0, 0, 0, 0.59);
            -moz-box-shadow: 0px 14px 51px -13px rgba(0, 0, 0, 0.59);
            box-shadow: 0px 14px 51px -13px rgba(0, 0, 0, 0.59);
            width: auto;
            transform: translateX(0) translateY(0);
            @include pddm_respond_to(sm-down){
                max-width : 300px;
            }

            img{
                max-width : 500px;
                width : auto;
                @include pddm_respond_to(md-down){
                    max-width: 100%;
                }
            }


            &.show {
                display: flex;

            }

            &.all {
                width: auto;
                display: flex;
                align-items: baseline;
                justify-content: space-between;
                @include pddm_respond_to(sm-down){
                    max-height : 300px;
                }
                > div {
                    width: 250px;
                    img{
                        display: block;
                        width: calc(100% - 5px);
                        margin: 5px auto;
                    }
                }
            }

            @include pddm_respond_to(xs-down){
                margin-top: 0 !important;
                transform: none !important;
            }

            &.hide {
                display: none;
            }
            &.top {
                transform: translateY(-100%);
                margin-top: -25px;
            }
            &.right.top {
                transform: translateX(-100%) translateY(-100%);
            }
            &.right.bottom {
                transform: translateX(-100%) translateY(0);
            }

        }

        &:first-child {
            padding-left: 0;
            text-align: left;
        }

        &:last-child {
            padding-right: 0;
            border-right: none;
            text-align: right;
            .image-hover{
                img{
                    max-width: 500px;
                    @include pddm_respond_to(sm-down){
                        max-width : 300px;
                    }
                }
            }
        }
    }

    .line {
        //background-image: url('../images/line.svg');
        height: 1em;
        width: 2px;
        background-size: auto 100%;
        background-position: center;
        background-repeat: repeat-y;
        margin-top: 6px;
    }
}
</style>




// WEBPACK FOOTER //
// resources/js/components/Common/VehicleHoverImages.vue